import { render, staticRenderFns } from "./QueryDetails.vue?vue&type=template&id=1fdfa3f7&"
import script from "./QueryDetails.vue?vue&type=script&lang=js&"
export * from "./QueryDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports